import base from "@/store/utils/api-route/base";
const WHITELABEL_BASE = `${base.masterData}whitelabel/`;
const api = {
  getDataDetailOwner: `${base.meta}data_detail_owner`,
  getCheckWhitelabel: `${base.masterData}whitelabel/cek_whitelabel`,
  getDetailPesanan: `${base.masterData}whitelabel/cicilan`,
  getCicilanWhitelabel: `${base.masterData}whitelabel/cicilan`,
  getDetailPembayaran: `${base.masterData}whitelabel/bayar`,
  getDataBank: `${base.masterData}whatsapp/list_bank_pembayaran`,
};

export default api;
